module.exports = __webpack_public_path__ + "static/img/8.6c2996e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/1/6/eng/8.png
// module id = ClV2
// module chunks = 0